import atlasApi from '..'

const productPrefix = '/brands/v2/products'

const getProductCatalog = async () => {
  const response = await atlasApi.get(productPrefix).catch((err) => err)
  return response
}

const getProductDetail = async (productId) => {
  const response = await atlasApi
    .get(`${productPrefix}/${productId}`)
    .catch((err) => err)

  return response
}

export { getProductCatalog, getProductDetail }
